import React, { lazy, Suspense } from "react";
import { HeroSlider } from "./components/HeroSlider";
import { SEO } from "../../components/common/SEO";

const TrainingGrid = lazy(() => import("./components/TrainingGrid").then(m => ({ default: m.TrainingGrid })));
const PhotoMosaic = lazy(() => import("./components/PhotoMosaic").then(m => ({ default: m.PhotoMosaic })));
const CallToActionBox = lazy(() => import("./components/CallToActionBox").then(m => ({ default: m.CallToActionBox })));
const TestimonialSection = lazy(() => import("../../components/sections/TestimonialSection").then(m => ({ default: m.TestimonialSection })));
const AppShowcase = lazy(() => import("./components/AppShowcase").then(m => ({ default: m.AppShowcase })));
const FaqSection = lazy(() => import("../../components/sections/FaqSection").then(m => ({ default: m.FaqSection })));
const CtaSection = lazy(() => import("../../components/sections/CtaSection").then(m => ({ default: m.CtaSection })));

export default function HomePage() {
  const homeSchema = {
    "@context": "https://schema.org",
    "@type": "SportsActivityLocation",
    "name": "Daneluci Performance",
    "alternateName": "Centro de Treinamento Daneluci",
    "url": "https://daneluciperformance.com.br",
    "logo": "https://res.cloudinary.com/tatikka/image/upload/v1765152724/Daneluci_-_Logo_Colorido_1_s7kzuf.jpg",
    "image": "https://res.cloudinary.com/tatikka/image/upload/v1765152724/Daneluci_-_Logo_Colorido_1_s7kzuf.jpg",
    "description": "Centro de treinamento de alta performance em Franca focado em treinamento funcional, ciclismo, MTB e recuperação de lesões.",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "Rua Arnaldo Vilhena, 1695",
      "addressLocality": "Franca",
      "addressRegion": "SP",
      "postalCode": "14401-136",
      "addressCountry": "BR"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": -20.5366,
      "longitude": -47.4009
    },
    "openingHoursSpecification": [
      {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
        "opens": "06:00",
        "closes": "21:00"
      }
    ],
    "sameAs": [
      "https://www.instagram.com/daneluciperfomance/"
    ]
  };

  return (
    <main className="ttkk-wrapper-content-page">
      <h1 className="sr-only">Daneluci Performance | Treino de Alta Performance em Franca</h1>
      <SEO 
        title="Daneluci Performance | Treinamento Funcional e Alta Performance" 
        description="Transforme seu desempenho com o método Daneluci. Especialistas em treinamento funcional do movimento e performance de elite em Franca."
        schema={homeSchema}
      />
      
      {/* LCP: HeroSlider carregado síncronamente para máxima velocidade */}
      <HeroSlider />

      {/* Componentes abaixo da dobra carregados em Lazy para desafogar a CPU Mobile */}
      <Suspense fallback={<div className="h-96 bg-neutral-900/5 animate-pulse rounded-[32px] mx-[5%] my-8" />}>
        <TrainingGrid />
        <PhotoMosaic />
        <TestimonialSection />
        <AppShowcase />
        <CallToActionBox />
        <CtaSection />
        <FaqSection />
      </Suspense>
    </main>
  );
}
